import {
  GridActionConfig,
  GridActionType,
  GridColumnType,
  GridConfig,
} from '../../../../shared/components/kendo/grid';
import { TEMPLATE_CONSTANTS } from '../../../human-resources/template/configurations/template-constants';
import { TEMPLATE_NOTIFICATION_CONSTANTS } from './template-notification-constant';

export const TEMPLATE_NOTIFICATION_PORTLET_CONFIG = TEMPLATE_NOTIFICATION_CONSTANTS.PORTLET_CONFIG;

export const getTemplateActions = (handlers: {
  onFinishSigning: (item: any) => void;
}): GridActionConfig[] => {
  const actions: GridActionConfig[] = [
    {
      id: 'template-signing',
      type: GridActionType.CUSTOM,
      text: 'Finish Signing',
      icon: '',
      handler: handlers.onFinishSigning,
      visible: () => true,
    },
  ];
  return actions;
};

export const createTemplateNotificationGridConfig = (actions: GridActionConfig[]): GridConfig => ({
  columns: [
    {
      field: 'fileName',
      title: 'Title',
      width: 180,
      filterable: true,
      sortable: true,
      type: GridColumnType.TEXT,
    },
    {
      field: 'syncstr',
      title: 'Sync Date',
      width: 180,
      filterable: true,
      sortable: true,
      type: GridColumnType.TEXT,
    },
    {
      field: 'actions',
      title: 'Actions',
      width: 120,
      filterable: false,
      sortable: false,
      type: GridColumnType.ACTIONS,
      actions: actions,
    },
  ],
  toolbarButtons: [],
  showSearch: true,
  pageable: {
    enabled: true,
    pageSize: TEMPLATE_CONSTANTS.DEFAULT_PAGE_SIZE,
    pageSizes: TEMPLATE_CONSTANTS.PAGE_SIZE_OPTIONS,
    showPageSizeSelector: true,
    showTotalCount: true,
    buttonCount: TEMPLATE_CONSTANTS.BUTTON_COUNT,
    previousNext: true,
    responsive: true,
  },
  sortable: {
    enabled: true,
    allowUnsort: true,
    mode: 'single' as any,
  },
  filterable: {
    enabled: true,
    mode: 'menu' as any,
  },
  groupable: {
    enabled: false,
  },
  selectable: {
    enabled: false,
  },
  resizable: true,
  reorderable: true,
});
